import React, { useEffect, useRef } from 'react';

/* ── 6. SVG path-draw connector ── */
function AnimatedConnector({ color }) {
  const lineRef = useRef(null);
  useEffect(() => {
    const el = lineRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.strokeDashoffset = '0';
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <svg width="2" height="40" style={{ display: 'block', margin: '4px auto 0', overflow: 'visible' }}>
      <line
        ref={lineRef}
        x1="1" y1="0" x2="1" y2="40"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="40"
        strokeDashoffset="40"
        style={{ transition: 'stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)' }}
      />
    </svg>
  );
}

export default function StepCard({ number, title, description, accentColor = '#3FC4E3', isLast = false }) {
  return (
    <div className="flex gap-4 relative">
      <div className="flex flex-col items-center">
        <div
          className="flex items-center justify-center w-8 h-8 rounded-full flex-shrink-0 z-10"
          style={{
            background: `${accentColor}18`,
            border: `1.5px solid ${accentColor}`,
            color: accentColor,
            fontFamily: 'popinsBold',
            fontSize: '13px',
          }}
        >
          {number}
        </div>
        {!isLast && <AnimatedConnector color={accentColor} />}
      </div>
      <div className="pb-6">
        <div style={{ fontFamily: 'popinsMedium', fontSize: '15px', color: '#1B1A28', marginBottom: '4px' }}>
          {title}
        </div>
        <div style={{ fontFamily: 'popinsRegular', fontSize: '14px', color: '#6B7280', lineHeight: '1.6' }}>
          {description}
        </div>
      </div>
    </div>
  );
}
